module.exports = __webpack_public_path__ + "img/IMG_5531.101f0347.jpg";